import React from "react";
import { Table, ColumnDefinition, Typography } from "@bracket/ui";
import { timeAgo } from "./timeAgo";
import { TablePlayerPlaysData, Choice } from "@bracket/in-or-out-server";
import { StyledChip } from "./StyledChip";
import styled from "styled-components";

type DailyPlayRecord = TablePlayerPlaysData[number];

export const TableYourDailyPlays: React.FC<{ data: TablePlayerPlaysData }> = ({
  data,
}) => {
  const columns: ColumnDefinition<DailyPlayRecord>[] = [
    {
      header: "Choice",
      accessor: "choice",
      render: (value: Choice) => (
        <StyledChip $color={value === "IN" ? "green" : "gray"}>
          {value ?? "No choice"}
        </StyledChip>
      ),
    },
    {
      header: "Time",
      accessor: "time",
      render: (value) => (
        <Typography variant="p" color="var(--text-paragraph)">
          {timeAgo(value)}
        </Typography>
      ),
    },
    {
      header: "Winning",
      accessor: "isWinning",
      render: (value: boolean) => (
        <StyledChip $color={value ? "green" : "gray"}>
          {value ? "Yes" : "No"}
        </StyledChip>
      ),
    },
    {
      header: "Total Bars Won",
      accessor: "total_bars",
    },
  ];

  return <Table data={data} columns={columns} />;
};
